(function (scope) {
  'use strict';
  const PRODUCT_ID = '7496462630935';
  const STOCK = 'Completely Stock';
  const MODIFIED = 'Modified with Stock Turbo';
  const FUELS = ['91', '93'];
  const PARTS = [
    ['injectors', 'Injectors'],
    ['hpfp', 'High-pressure fuel pump'], ['lpfp', 'Low-pressure fuel pump'],
    ['intake', 'Intake'], ['jpipe', 'J-pipe'], ['intercooler', 'Intercooler']
  ];
  const VARIANTS = {
    [STOCK]: {'91':'42017377452055', '93':'42017377484823'},
    [MODIFIED]: {'91':'42017377583127', '93':'42017377615895'}
  };
  const clean = value => String(value ?? '').trim();
  function effectiveLevel(setup) {
    return PARTS.some(([key]) => setup.parts[key]?.value === 'modified') || clean(setup.notes) ? MODIFIED : STOCK;
  }
  function selectedVariant(setup, product) {
    if (String(product?.productId) !== PRODUCT_ID || product.kind !== 'etune') return null;
    const id = VARIANTS[effectiveLevel(setup)]?.[setup.fuel];
    return product.variants?.find(variant => String(variant.id) === id && variant.option1 === effectiveLevel(setup) && variant.option2 === setup.fuel) || null;
  }
  function validate(setup) {
    const errors = [];
    if (!/^201[4-8]$/.test(setup.year)) errors.push('Select a model year from 2014 through 2018.');
    if (setup.transmission !== 'CVT') errors.push('This tune is for the Forester XT with CVT.');
    if (setup.turbo !== 'Stock') errors.push('This tune is for the stock turbo only.');
    if (!FUELS.includes(setup.fuel)) errors.push('Select a fuel.');
    for (const [key, label] of PARTS) {
      const part = setup.parts[key] || {};
      if (!['stock', 'modified'].includes(part.value)) errors.push('Select stock or modified for ' + label + '.');
      if (part.value === 'modified' && (!clean(part.brand) || clean(part.brand).length > 100)) errors.push('Enter the brand for ' + label + ' (up to 100 characters).');
      if (part.value === 'modified' && clean(part.model).length > 180) errors.push('Keep ' + label + ' part details within 180 characters.');
    }
    if (clean(setup.notes).length > 4000) errors.push('Keep other modifications and goals within 4,000 characters.');
    if (clean(setup.serial).length > 120) errors.push('Keep the Accessport serial within 120 characters.');
    return errors;
  }
  function properties(setup) {
    const data = {
      'Model Year': setup.year, 'Vehicle': 'Subaru Forester XT', 'Transmission Type': setup.transmission,
      'Fuel': setup.fuel, 'Turbo': 'Stock'
    };
    for (const [key, label] of PARTS) {
      const part = setup.parts[key];
      data[label] = part.value === 'modified'
        ? 'Modified — ' + [clean(part.brand), clean(part.model)].filter(Boolean).join(' · ')
        : 'Stock';
    }
    data.Accessport = setup.addAccessport ? 'Add COBB Accessport · AP3-SUB-004' : 'Use my own Accessport';
    if (!setup.addAccessport && clean(setup.serial)) data['AP Serial Number'] = clean(setup.serial);
    if (clean(setup.notes)) data['Other modifications & tuning goals'] = clean(setup.notes);
    return data;
  }
  function cartItems(setup, product) {
    const errors = validate(setup);
    if (errors.length) throw new Error(errors.join(' '));
    if (product.currency !== 'USD') throw new Error('Please select USD before purchasing this tune.');
    const variant = selectedVariant(setup, product);
    if (!variant) throw new Error('This tune option is not ready to purchase. Please refresh or contact us.');
    if (variant.available !== true) throw new Error('This tune option is currently unavailable. Please contact us.');
    const tuneCents = 45000;
    if (Number(variant.price) !== tuneCents) throw new Error('The pricing for this option has changed. Please refresh the page or contact us before purchasing.');
    const items = [{id: String(variant.id), quantity: 1, properties: properties(setup)}];
    if (setup.addAccessport) {
      if (String(product.accessportVariantId) !== '40479574196247' || product.accessportAvailable !== true || Number(product.accessportPrice) !== 77000) throw new Error('The Accessport is currently unavailable. Uncheck Add an Accessport to purchase only your tune.');
      items.push({id:'40479574196247',quantity:1});
    }
    return items;
  }
  const api = {PRODUCT_ID, STOCK, MODIFIED, FUELS, PARTS, VARIANTS, effectiveLevel, selectedVariant, validate, properties, cartItems};
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (!scope.document) return;
  const root = scope.document.querySelector('[data-forester-etune]');
  if (!root || root.dataset.cartInitialized) return;
  root.dataset.cartInitialized = 'true';
  const find = selector => root.querySelector(selector);
  const form = find('[data-production-form]');
  const button = find('[data-preview-cart]');
  const feedback = find('[data-preview-feedback]');
  let product;
  try { product = JSON.parse(find('[data-production-cart]').textContent); }
  catch { feedback.textContent = 'Please refresh the page to load the available tune options.'; return; }
  if (String(product.productId) !== PRODUCT_ID) return;
  const fuel = find('[data-fuel]');
  const addAccessport = find('[data-add-accessport]');
  const money = new Intl.NumberFormat('en-US', {style:'currency', currency:'USD', maximumFractionDigits:0});
  let pending = false;
  function readSetup() {
    return {
      year:find('[data-year]').value, transmission:'CVT', turbo:'Stock',
      fuel:fuel.value, addAccessport:addAccessport.checked,
      serial:find('#etune-ap-serial').value, notes:find('#etune-notes').value,
      parts:Object.fromEntries(PARTS.map(([key]) => [key, {
        value:find('[data-component="' + key + '"]').value,
        brand:find('[data-part-brand="' + key + '"]')?.value || '',
        model:find('[data-part-model="' + key + '"]')?.value || ''
      }]))
    };
  }
  function row(label, value) {
    const node = document.createElement('div');
    const term = document.createElement('dt'); const detail = document.createElement('dd');
    term.textContent = label; detail.textContent = value; node.append(term, detail); return node;
  }
  function render() {
    const setup = readSetup();
    const serial = find('#etune-ap-serial'); serial.disabled = setup.addAccessport;
    find('[data-ap-serial-field]').hidden = setup.addAccessport;
    for (const [key] of PARTS) {
      const select = find('[data-component="' + key + '"]');
      select.required = !select.disabled;
      const detail = find('[data-detail-for="' + key + '"]');
      if (!detail) continue;
      const modified = select.value === 'modified';
      detail.hidden = !modified; select.setAttribute('aria-expanded', String(modified));
      for (const field of detail.querySelectorAll('input')) {
        field.disabled = !modified;
        field.required = modified && field.hasAttribute('data-part-brand');
        field.setCustomValidity(field.required && !clean(field.value) ? 'Enter the brand for this modified part.' : '');
      }
    }
    [fuel, find('[data-year]')].forEach(field => field.required = true);
    const base = 450;
    const lines = [];
    let price = base;
    if (setup.addAccessport) { price -= 100; lines.push(row('Accessport bundle discount', '−$100')); }
    find('[data-price-lines]').replaceChildren(...lines);
    find('[data-price-lines]').hidden = lines.length === 0;
    find('[data-tune-subtotal]').textContent = money.format(price);
    find('[data-tune-subtotal]').dataset.amount = String(price);
    find('[data-accessport-pricing]').hidden = !setup.addAccessport;
    find('[data-accessport-price]').textContent = money.format(Number(product.accessportPrice) / 100);
    find('[data-order-subtotal]').textContent = money.format(price + Number(product.accessportPrice) / 100);
    find('[data-order-subtotal]').dataset.amount = String(price + Number(product.accessportPrice) / 100);
    find('[data-stock-shortcut]').disabled = !PARTS.some(([key]) => !setup.parts[key].value);
    if (!pending) {
      const availability = selectedVariant(setup, product);
      feedback.textContent = availability && availability.available !== true ? 'This tune option is currently unavailable. Please contact us.' : '';
    }
  }
  const preview = root.hasAttribute('data-preview-only');
  button.disabled = false;
  if (preview) button.textContent = 'Review configuration ↗';
  root.querySelectorAll('input,select,textarea').forEach(field => field.addEventListener('input', render));
  root.querySelectorAll('select,input[type="checkbox"]').forEach(field => field.addEventListener('change', render));
  find('[data-stock-shortcut]').addEventListener('click', () => {
    for (const [key] of PARTS) { const field = find('[data-component="' + key + '"]'); if (!field.value) field.value = 'stock'; }
    render();
  });
  form.addEventListener('submit', async event => {
    event.preventDefault(); if (pending) return; render();
    const setup = readSetup(); const errors = validate(setup);
    if (errors.length || !form.checkValidity()) {
      feedback.textContent = errors.join(' ') || 'Please complete the highlighted field.';
      const invalid = [...form.elements].find(field => field.willValidate && !field.checkValidity());
      if (invalid) { invalid.focus(); invalid.reportValidity(); }
      return;
    }
    let items;
    try { items = cartItems(setup, product); } catch (error) { feedback.textContent = error.message; return; }
    if (preview) { feedback.textContent = 'Your setup is complete. This preview does not add items to your cart.'; return; }
    const route = new URL(scope.Shopify?.routes?.root || '/', location.origin);
    if (route.origin !== location.origin) { feedback.textContent = 'Please refresh before adding your tune.'; return; }
    if (!route.pathname.endsWith('/')) route.pathname += '/';
    pending = true; button.disabled = true; button.setAttribute('aria-busy', 'true'); button.textContent = 'Adding…';
    feedback.textContent = 'Adding your tune to the cart…';
    try {
      const response = await fetch(new URL('cart/add.js', route), {method:'POST', credentials:'same-origin', headers:{'Content-Type':'application/json', Accept:'application/json'}, body:JSON.stringify({items})});
      let body; try { body = await response.json(); } catch {}
      if (!response.ok || body?.status >= 400 || !Array.isArray(body?.items) || items.some(requested => !body.items.some(item => String(item.variant_id ?? item.id) === requested.id))) throw new Error('We could not confirm the cart update. Check your cart before trying again.');
      feedback.textContent = 'Added to cart. Opening your cart…'; location.assign(new URL('cart', route).href);
    } catch (error) {
      feedback.replaceChildren(document.createTextNode('We could not confirm the cart update. Check your cart before trying again. '));
      const link = document.createElement('a'); link.href = new URL('cart', route).href; link.textContent = 'View cart'; feedback.append(link);
      pending = false; button.disabled = false; button.removeAttribute('aria-busy'); button.textContent = 'Add to cart ↗';
    }
  });
  const dialog = root.querySelector('dialog');
  find('[data-preview-image]')?.addEventListener('click', event => { event.preventDefault(); dialog.showModal(); });
  find('[data-close-image]')?.addEventListener('click', () => dialog.close());
  dialog?.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
  render();
})(typeof window === 'undefined' ? {} : window);
